var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonHuge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1545 26H29.8429C25.3729 26 22.5396 30.8218 24.7885 34.7199L39.7928 60.7264C40.7719 62.4245 43.2256 62.4245 44.2047 60.7264L59.212 34.7199C61.4578 30.8281 58.6246 26 54.1576 26H54.1545ZM39.7805 52.9274L36.5129 46.6033L28.6283 32.5016C28.1082 31.5991 28.7506 30.4425 29.8399 30.4425H39.7775V52.9305L39.7805 52.9274ZM55.363 32.4986L47.4815 46.6063L44.2138 52.9274V30.4394H54.1515C55.2407 30.4394 55.8832 31.596 55.363 32.4986Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonHuge);
export default __webpack_public_path__ + "static/media/ton_huge.329aa39842775f9de6c1da9cf0f35a96.svg";
export { ForwardRef as ReactComponent };